import React from "react";

const Home = () => {
    return (
        <div>Hello, world</div>
    );
};

export default Home;